<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-overlay :value="!loader">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
         <Strong>Note : If any data is not available or applicable.Kindly mention NA </Strong>
        <v-form id="subject_reg" @submit.prevent="submit" v-model="isValid">
            <v-row dense justify="center">
                <v-col cols="10" sm="10" md="10"> <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" /> </v-col>
            </v-row>
            <!-- {{registered_subjects}} -->
            <v-row dense justify="center" v-if="registered_subjects != null">
   <v-col cols="10" sm="10" md="10">
    <v-icon color="error" v-if="registered_subjects.required">*</v-icon>
     <v-autocomplete
            dense
            v-model="registered_subjects.field_value"
            :items="registered_subjects.options"
            item-text="name"
            item-value="id"
            single-line
            multiple
            :clearable="true"
            :prepend-icon="
              registered_subjects.field_value != null
                ? 'mdi-alpha-l-circle'
                : 'mdi-alpha-l-circle-outline'
            "
            :rules="
              registered_subjects.required
                ? [v => v.length!=0 || registered_subjects.field_display_name + ' is required']
                : []
            "
            :hint= registered_subjects.field_display_name
            persistent-hint
            outlined
          ></v-autocomplete>
 </v-col>
      </v-row>

            <v-row justify="center" dense>
                <v-col cols="10" sm="10" md="10">
                    <div style="text-align: center;">
                        <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit" :disabled="!isValid">Save</v-btn>
                    </div>
                </v-col>
            </v-row>
        </v-form>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data() {
            return {
                loader: false,
                isValid: true,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                application_form_data: {
                    admission_form_no: "",
                    admission_form_id: "",
                },
                registered_subjects:{},
                tenant: "wws",
                user_type: null,selected:[]
            };
            
        },
        methods: {
            submit: function (e) {
                this.loader = false;
                var form = document.getElementById("subject_reg");
                var formData = new FormData(form);
                 for (let i in this.registered_subjects.field_value) {
                        this.selected.push(this.registered_subjects.field_value[i]);
                    }
                    formData.append("selected_course",this.selected)
                axios.post("/admissionForm/saveSubjectRegistrationDetails", formData).then(
                    (response) => {
                        // success callback
                        console.log(response.data);
                        //this.form_progress=response.data.form_progress

                        if (response.data.form_saved == "YES") {
                            this.showSnackbar("#4caf50", 'Saved Successfully...Click on Next tab to Continue'); // show snackbar on success
                            this.disable_personal_email = true;
                            this.disable_mobile_no = true;
                        }
                        this.loader = true;
                        this.$store.commit("setform_progress", response.data.form_progress);
                    },
                    (response) => {
                        // error callback
                    }
                );
            },
            getform() {
                axios
                    .post("/admissionForm/subjectRegistrationDetails", this.application_form_data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.registered_subjects = res.data.registered_subjects;
                            this.$store.commit("setform_progress", res.data.form_progress);
                            this.loader = true;
                        }else if(res.data.flag=='No') {
                            this.showSnackbar("red", res.data.message); // show snackbar on success
                            this.$store.commit("setform_progress", res.data.form_progress);
                            this.loader = true;
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.application_form_data = this.$store.getters.application_form_data;
            this.getform();
        },
        created() {
            this.tenant = localStorage.getItem("EPS-tenant");
            this.user_type = localStorage.getItem("EPS-ut");
        },
    };
</script>
